import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { Button } from "../../ui/Button";
import { ToggleButton } from "../../ui/ToggleButton";
import { CalendarIcon2 } from "../../assets/svg/CalendarIcon2";
import { ClipBoardIcon } from "../../assets/svg/ClipBoardIcon";
import { Formik, Field } from "formik";
import { DropDown } from "../../ui/DropDown";
import DateRange from "../../ui/DateRange";
import {
  Switch,
  Route,
  useRouteMatch,
  useLocation,
  Redirect,
} from "react-router-dom";
import { Tasks } from "./Tasks";
import { Initiatives } from "./Initiatives";
import { AddInitiative } from "./AddInitiative";
import { get } from "../../utils/get";
import { GetHook } from "../../api/api";
import {
  PERSPECTIVE_URL,
  OBJECTIVE_URL,
  INITIATIVES_URL,
  USER_URL,
} from "../../api/urls";
import DateRangePicker2 from "../../ui/DateRangePicker";
import Modal from "../../ui/Modal";
import { AuthContext } from "../../context/AuthContext";
import useAuth from "../../hooks/useAuth";

export const Plan = () => {
  const { path } = useRouteMatch();
  const [openSidePane, setOpenSidePane] = useState(false);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [objectiveState, setObjectiveState] = useState<{}[]>([]);
  const [initiativeFilter, setInitiativeFilter] = useState();
  const [objectiveFilter, setObjectiveFilter] = useState();
  const [ownerFilter, setOwnerFilter] = useState();
  const [createdByFilter, setCreatedByFilter] = useState();
  const location = useLocation();
  const isInitiative = get(location, "pathname").includes("initiatives");
  const auth = useAuth();
  const { isManager } = auth;
  const { user } = get(auth, "authState");
  const { data: perspectives } = GetHook(PERSPECTIVE_URL);
  const { data: objectives } = GetHook(`${OBJECTIVE_URL}`);
  const { data: initiatives, reload } = GetHook(`${INITIATIVES_URL}`);
  const { data: owners } = GetHook(`${USER_URL}?limit=1000`);

  const loggedInUser = {
    label: get(user, "names"),
    value: get(user, "id"),
  };

  useEffect(() => {
    setOwnerFilter(get(loggedInUser, "value"));
  }, []);

  const ownersOptions = owners.map((owner) => {
    return { value: get(owner, "id"), label: get(owner, "names") };
  });

  const perspectiveOptions = perspectives.map((x) => {
    return { value: get(x, "id"), label: get(x, "name") };
  });

  const objectiveOptions = objectives.map((objective) => {
    return { value: get(objective, "id"), label: get(objective, "name") };
  });
  useEffect(() => {
    setObjectiveState(objectiveOptions);
    return () => {};
  }, [objectives]);

  return (
    <>
      {isModalOpen && (
        <Modal
          title="Add Task"
          noFooter
          noHeader
          closeModal={() => setisModalOpen(false)}
        >
          <AddInitiative
            onClick={() => setisModalOpen(false)}
            isOpen={openSidePane}
          />
        </Modal>
      )}
      <Formik
        initialValues={{ owner: loggedInUser }}
        onSubmit={(values) => console.log(values)}
      >
        {({ values, setFieldValue }) => (
          <>
            <PlanContainer>
              <PlanHeader>
                <TitleText>Plan</TitleText>
                {isManager() ? (
                  <Button
                    text={"New Initiative"}
                    onClick={() => setisModalOpen(true)}
                  />
                ) : null}
              </PlanHeader>
              <PlanFilters>
                <Field
                  name="owner"
                  component={DropDown}
                  width="auto"
                  dropdownLabel="Assigned to"
                  options={ownersOptions}
                  onChange={(values) => {
                    setOwnerFilter(get(values, "value"));
                    setFieldValue("owner", values);
                  }}
                  placeholder="Owners"
                  isBordered
                />
                <Field
                  name="created_by"
                  component={DropDown}
                  width="auto"
                  dropdownLabel="Created by"
                  options={ownersOptions}
                  onChange={(values) => {
                    setCreatedByFilter(get(values, "value"));
                    setFieldValue("created_by", values);
                  }}
                  placeholder="All"
                  isBordered
                />
                <Field
                  name="perspectives"
                  component={DropDown}
                  width="auto"
                  dropdownLabel="Perspectives"
                  options={perspectiveOptions}
                  placeholder="Perspectives"
                  onChange={(values) => {
                    const filteredObjectives = objectives
                      .filter(
                        (obj) =>
                          get(obj, "perspective_id") === get(values, "value")
                      )
                      .map((x) => {
                        return { value: get(x, "id"), label: get(x, "name") };
                      });
                    values
                      ? setObjectiveState(filteredObjectives)
                      : setObjectiveState(objectiveOptions);
                  }}
                  isBordered
                />
                <Field
                  name="objectives"
                  component={DropDown}
                  width="auto"
                  dropdownLabel="Objectives"
                  options={objectiveState}
                  onChange={(values) =>
                    setObjectiveFilter(get(values, "value"))
                  }
                  placeholder="Objectives"
                  isBordered
                />
                <DateRangeContainer>
                  <Field
                    name="date_range"
                    label="Time Period"
                    isClearable={true}
                    component={DateRangePicker2}
                    backgroundColor="#F5F6FB"
                  />
                </DateRangeContainer>
              </PlanFilters>
              <Switch>
                <Route exact path={`${path}`}>
                  <Redirect to={`${path}/initiatives`} />
                </Route>
                <Route path={`${path}/tasks`}>
                  <Tasks
                    initiativeFilter={initiativeFilter}
                    objectiveFilter={objectiveFilter}
                    dateFilter={get(values, "date_range", "")}
                  />
                </Route>
                <Route path={`${path}/initiatives`}>
                  <Initiatives
                    initiativeFilter={initiativeFilter}
                    objectiveFilter={objectiveFilter}
                    dateFilter={get(values, "date_range", "")}
                    ownersFilter={ownerFilter}
                    createdByFilter={createdByFilter}
                  />
                </Route>
              </Switch>
            </PlanContainer>
          </>
        )}
      </Formik>
    </>
  );
};

const PlanContainer = styled.div`
  display: grid;
  grid-template-rows: 5em 7em auto;
  background-color: #f5f6fb;
`;
const PlanHeader = styled.div`
  display: grid;
  grid-template-columns: auto 8em;
  grid-gap: 2em;
  border-bottom: 0.5px solid rgba(55, 81, 255, 0.1);
  align-items: center;
  padding: 0 2em 0 2em;
`;
const PlanFilters = styled.div`
  display: grid;
  margin: 1em 2em;
  grid-template-columns: 1fr 1fr 1fr 1fr 4fr;
  grid-gap: 1em;
`;

const DateRangeContainer = styled.div`
  justify-self: flex-end;
`;
